"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2948],{

/***/ 61740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_sign_up; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts.js + 3 modules
var consts = __webpack_require__(78679);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.scss.js

var StyledProductSignUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef6wzw60"
})("display:flex;flex-direction:row;height:50px;.product-logo-image{display:flex;align-items:center;.picture-component{img{width:160px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js















var _obj;
var PRODUCT_TYPE_TO_IMAGE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png"), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"), _obj);
var ProductSignUp = function(param) {
    var displayImage = param.displayImage, useCtaText = param.useCtaText, buttonSize = param.buttonSize, withButtonArrow = param.withButtonArrow, ctaText = param.ctaText, _productType = param.productType, productType = _productType === void 0 ? products/* WORK_MANAGEMENT_PRODUCT_ID */.py : _productType, _selectedProductIds = param.selectedProductIds, selectedProductIds = _selectedProductIds === void 0 ? [] : _selectedProductIds, signupClusterId = param.signupClusterId, useCtaIcon = param.useCtaIcon, _buttonColor = param.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.WHITE_COLOR_NAME : _buttonColor, invert = param.invert, excludeFromWMHighIntentExperienceTest = param.excludeFromWMHighIntentExperienceTest;
    var getProductsCookiesKey = function() {
        if (selectedProductIds.length === 1) {
            return selectedProductIds[0];
        }
        if (selectedProductIds.length === 2) {
            var sortedIds = selectedProductIds.sort();
            return "".concat(sortedIds[0], "_").concat(sortedIds[1]);
        }
        return null;
    };
    var updateClusters = function() {
        var res = [];
        if (selectedProductIds.length < 3) {
            selectedProductIds.forEach(function(id) {
                var clusterId = consts/* procuctIdToCluster */.Oh[id];
                if (clusterId) res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            });
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(res, clusters.HP_TAGS_SELECTION);
        }
    };
    var addTestCookiesAndClusters = function(cookieKey) {
        (0,cookies_service/* setCookie */.d8)(cookies.SKIP_AB_TESTS_HP, true, {
            expires: 1 // 1 day
        });
        (0,cookies_service/* setCookie */.d8)(cookies.MULTIPLE_PRODUCTS_SELECTION, true, {
            expires: 1 // 1 day
        });
        var productsKey = cookieKey || getProductsCookiesKey();
        if (productsKey) {
            var cookieArray = consts/* cookieValues */.$s[productsKey];
            cookieArray === null || cookieArray === void 0 ? void 0 : cookieArray.forEach(function(cookie) {
                (0,cookies_service/* setCookie */.d8)(cookie.key, cookie.value, {
                    expires: 1 // 1 day
                });
            });
        } else {
            (0,cookies_service/* setCookie */.d8)(cookies.INSTALL_PRODUCTS_FLOW, false, {
                expires: 1 // 1 day
            });
        }
        updateClusters();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductSignUp, {
        className: "product-sign-up",
        children: [
            displayImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-logo-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: PRODUCT_TYPE_TO_IMAGE[productType]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, {
                isWMHighIntentExperience: productType === products/* WORK_MANAGEMENT_PRODUCT_ID */.py,
                withButtonArrow: withButtonArrow,
                useCtaIcon: useCtaIcon,
                productIdToUse: productType,
                signupClusterId: signupClusterId,
                useCtaText: useCtaText,
                ctaText: ctaText,
                buttonSize: buttonSize || sizes.SM,
                buttonColor: buttonColor,
                invert: invert,
                beforeSubmitCallback: function() {
                    return addTestCookiesAndClusters(productType);
                },
                skipUpdateCluster: true,
                signupProductId: productType,
                extraData: {
                    selectedProduct: productType
                },
                excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
            })
        ]
    });
};
/* harmony default export */ var product_sign_up = (ProductSignUp);
ProductSignUp.defaultProps = default_props;


/***/ }),

/***/ 32948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ products_horizontal_timer_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/timer-vertical-tabs-desktop-component.js + 3 modules
var timer_vertical_tabs_desktop_component = __webpack_require__(14158);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title_title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-title/product-tab-title.scss.js



var StyledProductTabTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eui5zva0"
})("padding:10px 10px;display:flex;gap:10px;cursor:pointer;align-items:flex-start;.product-logo-wrapper{display:grid;grid-template-rows:1fr;grid-template-columns:1fr;.product-logo{opacity:1;grid-row:1 / 2;grid-column:1 / 2;transition:opacity 0.3s ease-in-out;}.selected-product-logo{opacity:0;grid-row:1 / 2;grid-column:1 / 2;transition:opacity 0.3s ease-in-out;}}.product-tab-title-text{color:", colors/* default.asphalt */.Z.asphalt, ";}&.selected-logo{.product-tab-title-text{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}}:hover{.product-tab-title-text{color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";}}&.logo-exists{&.selected-logo{.product-logo-wrapper{.product-logo{opacity:0;}.selected-product-logo{opacity:1;}}}:hover{.product-logo-wrapper{.product-logo{opacity:0;}.selected-product-logo{opacity:1;}}}}.product-tab-title-text{display:flex;height:100%;justify-content:center;flex-direction:column;.product-tab-title{font-weight:600;line-height:24px;}.paragraph-wrapper .paragraph-body{font-weight:400;}}.picture-component{img{width:45px;object-fit:contain;}}");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-title/product-tab-title.js







var ProductTabTitle = function(props) {
    var title = props.title, body = props.body, productImage = props.productImage, selectedProductImage = props.selectedProductImage, isSelected = props.isSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductTabTitle, {
        className: classnames_default()("product-title", {
            "selected-logo": isSelected,
            "logo-exists": selectedProductImage
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-logo-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-logo",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: productImage
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "selected-product-logo",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: selectedProductImage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-tab-title-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(title_title/* default */.Z, {
                        titleSize: sizes/* XS_ML */.l$,
                        title: title,
                        titleClassName: "product-tab-title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: body,
                        textSize: sizes.XS
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var product_tab_title = (ProductTabTitle);

// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs.js + 5 modules
var vertical_timer_tabs = __webpack_require__(34864);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-component.scss.js



var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var StyledProductsHorizontalTimerTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1x94450"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;width:fit-content;padding:0 ", HEADER_LOGO_HORIZONTAL_PADDING, " 0 0;.product-tabs-title-container{font-size:16px;font-weight:400;line-height:16px;letter-spacing:0px;text-align:left;}.timer-vertical-tabs-desktop-component{padding:0;width:100%;max-width:100%;.vertical-timer-tabs-container{flex-direction:column;.product-tab-content{.asset-container{width:100%;height:510px;}}.vertical-timer-tab-arrow-wrapper{display:none;}.vertical-timer-tab-desktop-content-container{}.desktop-tabs-text-container{flex-direction:row;min-height:auto;margin-right:0;.tab{height:fit-content;width:100%;&:first-of-type{min-width:250px;}&:nth-of-type(2){min-width:230px;}&:nth-of-type(3){min-width:235px;}.vertical-timer-tab-desktop-container{margin-bottom:0;position:relative;display:flex;flex-direction:column;align-items:flex-start;.vertical-timer-tab-desktop-progress-container{display:contents;height:100%;.progressbar{width:100%;margin-top:0;}}.vertical-timer-tab-desktop-title-button{display:flex;justify-content:center;}.vertical-timer-tab-desktop-title-button-selected{margin-bottom:0;}}}}}}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/default-props.js
/* harmony default export */ var default_props = ({
    maxLimit: 3,
    backgroundColor: "transparent",
    lineHeight: "auto",
    showButton: false,
    alwaysShowProgressbar: true,
    showArrow: false,
    tabs: [
        {
            productType: "work-management",
            title: {
                title: "Work Management",
                body: "Manage projects & tasks",
                productImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-031023/wm-dark.png",
                lineHeight: "100%"
            },
            tabContent: {
                productTags: [
                    {
                        text: "Projects "
                    },
                    {
                        text: "Tasks"
                    },
                    {
                        text: "Creative"
                    },
                    {
                        text: "Marketing"
                    },
                    {
                        text: "Operations"
                    }
                ],
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/global-041023/global-041023-wm-v1.png"
                    }
                }
            },
            asset: {
                image: {
                    src: null
                }
            }
        },
        {
            productType: "crm",
            title: {
                title: "Sales CRM",
                body: "Streamline sales cycle",
                productImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-031023/crm-dark.png"
            },
            tabContent: {
                productTags: [
                    {
                        text: "Sales leaders"
                    },
                    {
                        text: "Sales reps"
                    },
                    {
                        text: "Sales ops"
                    },
                    {
                        text: "Account managers"
                    }
                ],
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/global-041023/global-041023-crm-v1.png"
                    }
                }
            },
            asset: {
                image: {
                    src: null
                }
            }
        },
        {
            productType: "dev",
            title: {
                title: "Dev",
                body: "Deliver better products",
                productImage: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-031023/dev-dark.png"
            },
            tabContent: {
                productTags: [
                    {
                        text: "R&D"
                    },
                    {
                        text: "Product managers"
                    },
                    {
                        text: "Product designers"
                    },
                    {
                        text: "Agile teams"
                    }
                ],
                asset: {
                    image: {
                        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/global-041023/global-041023-dev-v1.png"
                    }
                }
            },
            asset: {
                image: {
                    src: null
                }
            }
        }
    ],
    timerEnabled: false,
    tabsTitle: {
        titleText: "Find the right product for your team",
        titleMarginBottom: "20px"
    },
    theme: "background-gray"
});

// EXTERNAL MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js + 2 modules
var product_sign_up = __webpack_require__(61740);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-content/product-tab-content-tags-component.scss.js



var StyledProductTabContentTagsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eqelta20"
})("display:flex;justify-content:space-between;align-items:center;width:100%;height:80px;.product-sign-up{height:auto;.signup-text{font-weight:400;}}.product-tags-container{display:flex;gap:8px;}.product-tag{font-size:14px;font-weight:400;line-height:13px;letter-spacing:0px;color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";padding:6px 12px;border-radius:4px;}");

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-content/product-tab-content-tags-component.js







var _obj;
var PRODUCT_COLORS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "#D4D4FE"), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "#BEDDE3"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "#D5EADE"), _obj);
var _obj1;
var PRODUCT_TEXTS_COLORS = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME), (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, color_consts.CRM_DARKER_TINT_02), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, color_consts.DEV_DARKER_TINT_02_COLOR_NAME), _obj1);
var _obj2;
var PRODUCT_BUTTON_COLORS = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME), (0,_define_property/* default */.Z)(_obj2, products/* CRM_PRODUCT_ID */.$, color_consts.CRM_DARKER_TINT_02_COLOR_NAME), (0,_define_property/* default */.Z)(_obj2, products/* DEV_PRODUCT_ID */.xi, color_consts.DEV_DARKER_TINT_02_COLOR_NAME), _obj2);
var _obj3;
var CTA_TEXT = (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "Try Work Management"), (0,_define_property/* default */.Z)(_obj3, products/* CRM_PRODUCT_ID */.$, "Try Sales CRM"), (0,_define_property/* default */.Z)(_obj3, products/* DEV_PRODUCT_ID */.xi, "Try Dev"), _obj3);
var ProductTabContentTagsComponent = function(param) {
    var tags = param.tags, productType = param.productType;
    var productColor = PRODUCT_COLORS[productType];
    var productTextColor = PRODUCT_TEXTS_COLORS[productType];
    var productButtonColor = PRODUCT_BUTTON_COLORS[productType];
    var ctaText = CTA_TEXT[productType];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductTabContentTagsComponent, {
        className: "product-tags-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-tags-container",
                children: tags.map(function(tag, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-tag",
                        style: {
                            backgroundColor: productColor,
                            color: colors/* default */.Z[productTextColor]
                        },
                        children: tag.text
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(product_sign_up/* default */.Z, {
                buttonSize: "xs",
                productType: productType,
                buttonColor: productButtonColor,
                useCtaText: true,
                ctaText: ctaText,
                useCtaIcon: false,
                invert: true
            })
        ]
    });
};
/* harmony default export */ var product_tab_content_tags_component = (ProductTabContentTagsComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-content/product-tab-content-component.scss.js

var StyledProductTabContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejp8wl10"
})("width:100%;");

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-content/product-tab-content-component.js
function product_tab_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_tab_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var ProductTabContentComponent = function(param) {
    var content = param.content, productType = param.productType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductTabContentComponent, {
        className: "product-tab-content",
        children: [
            (content === null || content === void 0 ? void 0 : content.productTags) && /*#__PURE__*/ (0,jsx_runtime.jsx)(product_tab_content_tags_component, {
                tags: content.productTags,
                productType: productType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "asset-container",
                children: (content === null || content === void 0 ? void 0 : content.asset) && /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, content.asset))
            })
        ]
    });
};
/* harmony default export */ var product_tab_content_component = (ProductTabContentComponent);

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-component.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_horizontal_timer_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var products_horizontal_timer_tabs_component_obj;
var PRODUCT_COLORS_NAMES = (products_horizontal_timer_tabs_component_obj = {}, (0,_define_property/* default */.Z)(products_horizontal_timer_tabs_component_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, color_consts.BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME), (0,_define_property/* default */.Z)(products_horizontal_timer_tabs_component_obj, products/* CRM_PRODUCT_ID */.$, color_consts.CRM_DARKER_TINT_02_COLOR_NAME), (0,_define_property/* default */.Z)(products_horizontal_timer_tabs_component_obj, products/* DEV_PRODUCT_ID */.xi, color_consts.DEV_DARKER_TINT_02_COLOR_NAME), products_horizontal_timer_tabs_component_obj);
var ProductsHorizontalTimerTabsComponent = function(_param) {
    var tabsTitle = _param.tabsTitle, contentRenderer = _param.contentRenderer, overrideTabs = _param.overrideTabs, progressbarColor = _param.progressbarColor, renderDesktopTabsOnly = _param.renderDesktopTabsOnly, verticalTimerTabsProps = _object_without_properties(_param, [
        "tabsTitle",
        "contentRenderer",
        "overrideTabs",
        "progressbarColor",
        "renderDesktopTabsOnly"
    ]);
    var ref = (0,react.useState)(), currentProduct = ref[0], setCurrentProduct = ref[1];
    var title = {
        lineHeight: "100%"
    };
    var rightSideRenderer = function(currentTab) {
        // this renders the tab's content
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_tab_content_component, {
            content: currentTab.tabContent,
            productType: currentTab.productType
        });
    };
    var tabTitleRenderer = function(tabTitle, param) {
        var isSelected = param.isSelected;
        if (!tabTitle) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_tab_title, _object_spread_props(products_horizontal_timer_tabs_component_object_spread({}, tabTitle), {
            isSelected: isSelected
        }));
    };
    var onTabChangedHandler = function(newTab) {
        setCurrentProduct(newTab.productType);
    };
    var getTabsProps = function() {
        return overrideTabs || verticalTimerTabsProps;
    };
    var getProgressBarColor = function() {
        return progressbarColor || PRODUCT_COLORS_NAMES[currentProduct] || PRODUCT_COLORS_NAMES[products/* WORK_MANAGEMENT_PRODUCT_ID */.py];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductsHorizontalTimerTabsComponent, {
        className: "products-horizontal-timer-tabs-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-tabs-title-container",
                style: {
                    marginBottom: tabsTitle === null || tabsTitle === void 0 ? void 0 : tabsTitle.titleMarginBottom
                },
                children: tabsTitle === null || tabsTitle === void 0 ? void 0 : tabsTitle.titleText
            }),
            !renderDesktopTabsOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_timer_tabs/* default */.Z, _object_spread_props(products_horizontal_timer_tabs_component_object_spread({
                tabTitleRenderer: tabTitleRenderer,
                rightSideRenderer: contentRenderer || rightSideRenderer,
                onTabChangedHandler: onTabChangedHandler,
                progressbarColor: getProgressBarColor(),
                title: title,
                getTabIdentifier: function(tab) {
                    return tab.productType;
                }
            }, tabsTitle, verticalTimerTabsProps), {
                tabs: getTabsProps()
            })),
            renderDesktopTabsOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(timer_vertical_tabs_desktop_component/* default */.Z, _object_spread_props(products_horizontal_timer_tabs_component_object_spread({
                tabTitleRenderer: tabTitleRenderer,
                rightSideRenderer: contentRenderer || rightSideRenderer,
                onTabChangedHandler: onTabChangedHandler,
                progressbarColor: getProgressBarColor(),
                title: title,
                getTabIdentifier: function(tab) {
                    return tab.productType;
                }
            }, tabsTitle, verticalTimerTabsProps), {
                tabs: getTabsProps()
            }))
        ]
    });
};
ProductsHorizontalTimerTabsComponent.defaultProps = default_props;
/* harmony default export */ var products_horizontal_timer_tabs_component = (ProductsHorizontalTimerTabsComponent);


/***/ })

}]);